// Sınırsız (unlimited) katalog önbelleği.
//
// Önbellek mekanizması ve liste yardımcıları bundleCatalog.js'te ortaklaştı
// (ses paketleri de aynısını kullanıyor). Burada yalnızca sınırsıza özel olan
// kısım kalır: satın alınmış bir siparişin sınırsız pakete ait olup olmadığı.
//
// İkinci kullanıcı: hesap ekranı. Satın alınmış bir siparişin sınırsız olup
// olmadığına `clientProductId` → `plan.isUnlimited` eşlemesiyle karar veriyoruz.
// "ID >= 100000 ise yenidir" sezgisi bilerek KULLANILMIYOR: doküman bu aralığı
// frontend için sözleşme saymıyor, sadece bilgi olarak veriyor (§1).

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  createBundleCatalog,
  findBundle,
  sortedPlans,
  isSellable,
} from './bundleCatalog';

const catalog = createBundleCatalog('unlimited');

export const loadUnlimitedBundles = catalog.load;
export const resetUnlimitedBundles = catalog.reset;

export const findUnlimitedBundle = findBundle;
export const sellablePlans = sortedPlans;
export { isSellable };

const planIdSet = (bundles) => {
  const set = new Set();
  (bundles || []).forEach((b) =>
    (b.plans || []).forEach((p) => {
      if (p.isUnlimited) set.add(String(p.id));
    })
  );
  return set;
};

/**
 * Sınırsız plan kimlikleri. Yüklenene kadar `null` döner — çağıran taraf bu
 * sürede sınırsız uyarlaması YAPMAMALI (yanlışlıkla veri çubuğu gizlenmesin).
 * Katalog çekilemezse boş küme döner: eski davranış korunur.
 */
export const useUnlimitedPlanIds = () => {
  const { i18n: i18next } = useTranslation();
  const [ids, setIds] = useState(null);

  useEffect(() => {
    let cancelled = false;
    loadUnlimitedBundles()
      .then((list) => !cancelled && setIds(planIdSet(list)))
      .catch(() => !cancelled && setIds(new Set()));
    return () => {
      cancelled = true;
    };
  }, [i18next.language]);

  return ids;
};

// Bir sipariş satırı sınırsız pakete mi ait? `ids` yüklenmemişse false.
export const isUnlimitedOrder = (ids, esim) =>
  Boolean(ids && esim?.clientProductId != null && ids.has(String(esim.clientProductId)));
